// AIDEV-NOTE: PolemkAuth engine assets pack - independent with jQuery + Slick
// Import jQuery and expose globally for engine compatibility
import 'jquery';
import 'jquery-mask-plugin';


// Import Slick Carousel for slider functionality
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'tippy.js';
import twemoji from '@twemoji/api';

global.twemoji = twemoji;
import tippy, { followCursor } from 'tippy.js';
global.tippy = tippy;

// Imports CSS directly from engine location via additional_paths
import 'polemk_auth/index.scss';

console.log("✅ PolemkAuth loaded: jQuery + Slick + CSS from engine");